import _ from 'lodash';
import React, { useMemo } from 'react';
import { AllocationBillableTypeFilter, SingleSelectFilter, YesNoFilter } from '~/components';
import { ClientFiltersBar, MemberFiltersBar, ProjectFiltersBar, ResourceFiltersBar } from '~/components/filters';
import { useFeatures } from '~/hooks';
import FiltersBarContainer from '../../components/FiltersBar';
import MetricRangeFilter from './MetricRangeFilter';

export default function FiltersBar({ params: filters, onFilterChange, onMetricChange }) {
  return (
    <FiltersBarContainer>
      <MetricFilter value={filters.metric} onChange={({ target: { value } }) => onMetricChange(value)} />

      <MetricRangeFilter
        metric={filters.metric}
        unit={filters.unit}
        value={{ min: filters.metricRangeMin, max: filters.metricRangeMax }}
        onChange={({ min, max }) => onFilterChange({ metricRangeMin: min, metricRangeMax: max })}
      />

      <YesNoFilter
        icon="filter"
        placeholder="Only resources with allocations"
        value={filters.onlyAllocatedResources === true ? 'yes' : 'no'}
        onChange={({ value }) => onFilterChange({ onlyAllocatedResources: value === 'yes' })}
      />

      <ClientFiltersBar filters={filters} onChange={onFilterChange} />

      <ProjectFiltersBar filters={filters} onChange={onFilterChange} />

      <MemberFiltersBar filters={filters} onChange={onFilterChange} />

      <ResourceFiltersBar filters={filters} onChange={onFilterChange} />

      {!_.isEmpty(filters.allocationBillableTypes) && (
        <AllocationBillableTypeFilter
          value={filters.allocationBillableTypes}
          onChange={({ target: { value } }) => onFilterChange({ allocationBillableTypes: value })}
        />
      )}
    </FiltersBarContainer>
  );
}

const metrics = [
  { id: 'all_hours', name: 'All Hours' },
  { id: 'project_hours', name: 'Project Hours' },
  { id: 'billable_hours', name: 'Billable Hours' },
  { id: 'productive_hours', name: 'Productive Hours' },
  { id: 'available_hours', name: 'Available Hours' },
  { id: 'billable_utilization', name: 'Billable Utilization' },
  { id: 'client_utilization', name: 'Client Utilization' },
  { id: 'productive_utilization', name: 'Productive Utilization' },
  { id: 'total_utilization', name: 'Total Utilization' },
  { id: 'target_attainment', name: 'Target Attainment' },
];

function MetricFilter({ value, onChange }) {
  const features = useFeatures();

  // Remove the utilization metrics from the dropdown options if the feature is not enabled.
  const options = useMemo(() => {
    return features.utilization
      ? metrics
      : Object.values(
          _.omitBy(metrics, ({ id }) =>
            [
              'billable_utilization',
              'productive_utilization',
              'target_attainment',
              'client_utilization',
              'total_utilization',
            ].includes(id),
          ),
        );
  }, [features.utilization]);

  return (
    <SingleSelectFilter
      icon="gear"
      placeholder="Metric"
      clearable={false}
      options={options}
      value={value}
      onChange={onChange}
    />
  );
}
